export default __webpack_public_path__ + "static/yee-han-chung-b1a091bb7326298631f13809d48fa45f.jpeg";